// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__64090","active":"Switch_active__6jSWj","switch-thumb":"Switch_switch-thumb__RBV1Y"};